import gql from "graphql-tag";
const runFields = gql`fragment ReconciliationRun on InventoryReconciliationRun {
  _id kind fileName status message error createdAt exportedAt startedAt finishedAt vendors inputCount resultCount
  summary { status label count }
}`;
export const runsQuery = gql`query inventoryReconciliationRuns($shopId: ID!) {
  inventoryReconciliationRuns(shopId: $shopId) { ...ReconciliationRun }
} ${runFields}`;
export const runQuery = gql`query inventoryReconciliationRun($runId: ID!) {
  inventoryReconciliationRun(runId: $runId) { ...ReconciliationRun }
} ${runFields}`;
export const createMutation = gql`mutation createInventoryReconciliation($input: CreateInventoryReconciliationInput!) {
  createInventoryReconciliation(input: $input) { ...ReconciliationRun }
} ${runFields}`;
export const rowsQuery = gql`query inventoryReconciliationRows($input: InventoryReconciliationRowsInput!) {
  inventoryReconciliationRows(input: $input) {
    totalCount checkedAt changedCount summary { status label count }
    nodes { rowId status statusLabel productId productNumber serialNumber title vendor virtualProductSuffix localization storage storageBin
      inLimes inShop listed orderable canBackorder inventoryInStock inventoryReserved inventoryAvailableToSell price variantId slug inputRows note
      changes { field previousValue } }
  }
}`;
export const exportQuery = gql`query inventoryReconciliationExport($runId: ID!) {
  inventoryReconciliationExport(runId: $runId, current: true) { fileName contentBase64 totalCount }
}`;

export const createShopExportMutation = gql`mutation createInventoryShopExport($shopId: ID!, $vendors: [Vendor!]!) {
  createInventoryShopExport(shopId: $shopId, vendors: $vendors) { ...ReconciliationRun }
} ${runFields}`;
